import { useEffect } from 'react';
import { keyboardInset } from '@/features/chat/composer/composerHeight';

/**
 * Keeps `--keyboard-height` on <html> at the height the on-screen keyboard
 * covers (Chrome on Android shrinks only the visual viewport), so bottom
 * sheets rest on the keyboard instead of under it, as the kit's do.
 */
export const useKeyboardHeight = () => {
  useEffect(() => {
    const viewport = window.visualViewport;
    if (!viewport) return undefined;
    const root = document.documentElement;
    const update = () => {
      // Pinch zoom also shrinks the visual viewport; that is not a keyboard.
      const zoomed = Math.abs(viewport.scale - 1) > 0.01;
      const inset = zoomed
        ? 0
        : keyboardInset({
            layoutHeight: window.innerHeight,
            visualHeight: viewport.height,
            visualOffsetTop: viewport.offsetTop,
          });
      root.style.setProperty('--keyboard-height', `${inset}px`);
      // A panned visual viewport shows less than layout - keyboard; sheets
      // never grow taller than what is visible.
      root.style.setProperty(
        '--visual-height',
        zoomed ? '100dvh' : `${Math.round(viewport.height)}px`,
      );
    };
    update();
    viewport.addEventListener('resize', update);
    viewport.addEventListener('scroll', update);
    return () => {
      viewport.removeEventListener('resize', update);
      viewport.removeEventListener('scroll', update);
      root.style.removeProperty('--keyboard-height');
      root.style.removeProperty('--visual-height');
    };
  }, []);
};
